import { useField } from 'formik';
import React__default, { useMemo, useCallback } from 'react';
import styled from 'styled-components';
import { ButtonIcon } from '../button/ButtonIcon.js';
import { FieldErrorMessage } from '../fields/FieldError.js';
import { Icon } from '../icon/Icon.js';
import { Box } from '../layout/Box.js';
import { Column } from '../layout/Column.js';
import { Columns } from '../layout/Columns.js';
import { Inline } from '../layout/Inline.js';
import { Text } from '../text/Text.js';

const StyledBox = styled(Box)`
  && [${FieldErrorMessage.dataId}] {
    margin-top: 0;
    min-height: 0;
  }
`;
const isReactElement = (node)=>{
    return !!node?.props;
};
const isNonEmptyIfArray = (arr)=>{
    if (Array.isArray(arr)) {
        return arr?.length > 0;
    }
    return true;
};
const FilterField = ({ testId ="X" , children , ...props })=>{
    const child = useMemo(()=>{
        const l = [];
        const f = [];
        let name = "";
        for (const c of React__default.Children.toArray(children)){
            if (typeof c === "string") {
                l.push(c);
            } else if (c !== undefined && c !== null) {
                f.push(c);
                if (isReactElement(c) && !!c?.props.name) {
                    name = c?.props.name;
                }
            }
        }
        return {
            labels: l,
            field: f,
            name
        };
    }, [
        children
    ]);
    const [field, _, helpers] = useField(child.name);
    const active = field.value !== undefined && field.value !== null && field.value !== "" && field.value !== false && isNonEmptyIfArray(field.value);
    const clear = useCallback(()=>{
        const empty = Array.isArray(field.value) ? [] : undefined;
        helpers.setValue(empty);
    }, [
        field.value,
        helpers
    ]);
    return React__default.createElement(StyledBox, {
        "data-hpy-web-table-filter-field": true,
        ...props,
        border: "solid",
        borderColor: active ? "context" : "slateGrey10",
        borderRadius: "medium",
        width: "fill",
        minHeight: 3.875,
        padding: [
            0,
            1
        ]
    }, React__default.createElement(Columns, {
        height: "fill"
    }, React__default.createElement(Column, null, React__default.createElement(Inline, {
        wrap: false,
        alignY: "center",
        gap: 0.75,
        width: "fill"
    }, active && React__default.createElement(ButtonIcon, {
        testId: "FilterField-Clear-" + testId,
        icon: "close",
        variant: "context",
        size: "xsmall",
        onClick: clear
    }), !active && React__default.createElement(Icon, {
        icon: "filter",
        size: "xsmall"
    }), React__default.createElement(Text, null, child.labels))), React__default.createElement(Column, null, React__default.createElement(Inline, {
        wrap: false,
        alignY: "center",
        align: "right",
        width: "fill",
        height: "fill"
    }, child.field))));
};
FilterField.dataId = "data-hpy-web-table-filter-field";
FilterField.displayName = "FilterField";

export { FilterField };
